export const Bio = {
    FirstName: "Kaustubh",
    FullName: "Kaustubh Hiware",
    Name: [
        {
            Lang: "English",
            Name: "Kaustubh Hiware",
            Emoji: "🇬🇧",
        },
        {
            Lang: "Hindi",
            Name: "कौस्तुभ हिवरे",
            Emoji: "🇮🇳",
        },
        {
            Lang: "Japanese",
            Name: "ヒワレ　コサトバ",
            Emoji: "🇯🇵",
        }
    ],
    Role: "Software Engineer",
    Location: "Tokyo",
    URLs: {
        Twitter: "https://twitter.com/_ofkaus",
        LinkedIn: "https://www.linkedin.com/in/ofkaus/",
        Github: "https://github.com/kaustubhhiware",
        GoogleScholar: "https://scholar.google.com/citations?hl=en&user=9iIiFjMAAAAJ",
        Email: "hiwarekaustubh+web@gmail.com",
        Podcast: "https://techculturepodcast.com",
    },
    Intro: [
        "I'm a Senior Software Engineer at Mercari with an interest in product SaaS businesses.\n",
        "In free time, I go on roadtrips around Japan and take pictures. I find humor in all things.\n", 
    ],
    Erdos: {
        Number: "4",
        URL: "https://www.csauthors.net/distance/paul-erdos/kaustubh-hiware",
    },
    GATrackingID: "G-13DZQ5P64Z",
};

export default Bio;
export const LangDefault = "0";
